export default "__VITE_ASSET__BAMZwN0i__"